
function floor (number) {
  return ~~(number - (number < 0 ? 1 : 0))
}

function configure (isLittleEndian, isDouble) {
  return isDouble && isLittleEndian
    ? [52, 11, 7, -1]
    : isLittleEndian
      ? [23, 8, 3, -1]
      : isDouble
        ? [52, 11, 0, 1]
        : [23, 8, 0, 1]
}

function configureW (isLittleEndian, isDouble) {
  return isDouble && isLittleEndian
    ? [52, 11, 0, 1]
    : isLittleEndian
      ? [23, 8, 0, 1]
      : isDouble
        ? [52, 11, 7, -1]
        : [23, 8, 3, -1]
}

export function read (buffer, offset, isLittleEndian, isDouble) {
  let exponent, mantissa
  let [mantissaLength, exponentLength, i, d] = configure(isLittleEndian, isDouble)
  const exponentMax = (1 << exponentLength) - 1
  const exponentBias = exponentMax >> 1
  let bitLength = -7
  let s = buffer[offset + i]

  i += d

  exponent = s & ((1 << (-bitLength)) - 1)
  s >>= (-bitLength)
  bitLength += exponentLength
  while (bitLength > 0) {
    exponent = (exponent * 256) + buffer[offset + i]
    i += d
    bitLength -= 8
  }

  mantissa = exponent & ((1 << (-bitLength)) - 1)
  exponent >>= (-bitLength)
  bitLength += mantissaLength
  while (bitLength > 0) {
    mantissa = (mantissa * 256) + buffer[offset + i]
    i += d
    bitLength -= 8
  }

  if (exponent === 0) {
    exponent = 1 - exponentBias
  } else if (exponent === exponentMax) {
    return mantissa ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    mantissa = mantissa + Math.pow(2, mantissaLength)
    exponent = exponent - exponentBias
  }
  return (s ? -1 : 1) * mantissa * Math.pow(2, exponent - mantissaLength)
}

export function write (buffer, value, offset, isLittleEndian, isDouble) {
  let exponent, mantissa, c
  let [mantissaLength, exponentLength, i, d] = configureW(isLittleEndian, isDouble)
  const exponentMax = (1 << exponentLength) - 1
  const exponentBias = exponentMax >> 1
  const rt = (mantissaLength === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  const s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    mantissa = isNaN(value) ? 1 : 0
    exponent = exponentMax
  } else {
    exponent = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -exponent)) < 1) {
      exponent--
      c *= 2
    }
    if (exponent + exponentBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - exponentBias)
    }
    if (value * c >= 2) {
      exponent++
      c /= 2
    }

    if (exponent + exponentBias >= exponentMax) {
      mantissa = 0
      exponent = exponentMax
    } else if (exponent + exponentBias >= 1) {
      mantissa = ((value * c) - 1) * Math.pow(2, mantissaLength)
      exponent = exponent + exponentBias
    } else {
      mantissa = value * Math.pow(2, exponentBias - 1) * Math.pow(2, mantissaLength)
      exponent = 0
    }
  }

  while (mantissaLength >= 8) {
    buffer[offset + i] = mantissa & 0xff
    i += d
    mantissa /= 256
    mantissaLength -= 8
  }

  exponent = (exponent << mantissaLength) | mantissa
  exponentLength += mantissaLength
  while (exponentLength > 0) {
    buffer[offset + i] = exponent & 0xff
    i += d
    exponent /= 256
    exponentLength -= 8
  }

  buffer[offset + i - d] |= s * 128
}

function power (x, y) {
  let result = 1

  if (x < 0 && y < 1 && y > 0) {
    return NaN
  }
  if (y < 0) {
    y = -y
    return 1 / power(x, y)
  }
  if (y < 1 || y === Infinity || y === -Infinity) {
    return x ** y
  }

  while (y > 0) {
    if (y % 2 === 0) {
      // y is even
      x = x * x
      y = floor(y / 2)
    } else {
      result = result * x
      --y
    }
  }

  return result
}
